import { NgModule } from "@angular/core";
import { ControlMessagesComponent } from "./control-messages.component";
import { ValidationService } from "../../services/validation.service";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        ControlMessagesComponent
    ],
    declarations: [
        ControlMessagesComponent
    ],
    providers: [
        ValidationService
    ]
})

export class ControlMessagesModule {
}


// WEBPACK FOOTER //
// ./src/app/components/validation/control-messages.module.ts